/**
 * VendorsLandingPage — https://vendors.hustlesuite.au/
 */
import { Link } from "react-router-dom";
import {
  Store, DollarSign, Ticket, Users, ArrowRight, ShieldCheck,
} from "lucide-react";
import PlatformHeader from "@/components/PlatformHeader";
import SuiteFooter from "@/components/SuiteFooter";

const CARDS = [
  { icon: Store,        title: "Vendor Terminal",   to: "/venue-terminal",       desc: "POS, Points redemption, kiosk PINs for your team." },
  { icon: DollarSign,   title: "Points redemption", to: "/vendor/redeem-points", desc: "Scan a member's QR to redeem 10 pts → $1." },
  { icon: Ticket,       title: "Event ticketing",   to: "/events",               desc: "Sell tickets, book tables, run doors." },
  { icon: Users,        title: "My account",        to: "/account",              desc: "Business profile · payouts · staff PINs." },
  { icon: ShieldCheck,  title: "Verified partners", to: "/venue-partners/apply", desc: "Apply to be a HustleMeet verified partner venue." },
];

export default function VendorsLandingPage() {
  return (
    <div data-testid="vendors-landing" className="min-h-screen bg-[#FDFBF7] text-[#121614]">
      <PlatformHeader
        brand={{ name: "HustleSuite · Vendors", to: "/" }}
        showBookCta={false}
        showCart={false}
      />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <p className="text-xs uppercase tracking-[0.22em] font-bold text-[#5A7247]">
          Vendors portal
        </p>
        <h1 className="mt-2 font-serif-display text-4xl sm:text-5xl leading-tight">
          Sell, redeem, and grow — all from one dashboard.
        </h1>
        <p className="mt-3 text-[#3C423F] max-w-xl">
          Every HustleSuite vendor also gets a HustleMember account —
          switch between the two in your account any time.
        </p>
        <section className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CARDS.map(({ icon: Icon, title, to, desc }) => (
            <Link
              key={title}
              to={to}
              data-testid={`vendors-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white border border-[#E8E5DF] rounded-2xl p-5 hover:border-[#5A7247] hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-[#5A7247]/10 text-[#5A7247] flex items-center justify-center">
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <h3 className="mt-4 font-serif-display text-2xl">{title}</h3>
              <p className="mt-1.5 text-sm text-[#3C423F]">{desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#C05746] group-hover:gap-2 transition-all">
                Open <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          ))}
        </section>
      </main>
      <SuiteFooter />
    </div>
  );
}
